import { useRouter } from "next/router";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { useMutation } from "@apollo/client";
import { CLOSE_LISTING } from "@/graphql/queries/listing";
import { DropDown, Modal } from "@aqar-app/react-ui";
import css from "@/components/Listing/ListingScreen/.module.scss";
import Link from "next/link";
import React from "react";

import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import Icon from "@/components/icon";
import {
  trackEditListingComplete,
  trackStartEditListing,
} from "@/lib/tracking/trackEditListing";
import { useListingStatusControl } from "@/hooks/useListingStatusControl";

export function OwnerControls({ listing } = {}) {
  const router = useRouter();
  const { user, token } = useAuthState();
  const [closeListing] = useMutation(CLOSE_LISTING, {
    context: { token },
  });
  const authUserId = user?.user_id;

  const isPaused = listing?.status === 5;

  const handleCloseListing = (e, { id }) => {
    Modal.open(
      <ClassicModal
        ok={{
          label: "نعم",
          cb: (e) => {
            ClassicModal.loading("ok")(e);
            closeListing({
              variables: {
                id,
              },
            })
              .then(() => {
                trackEditListingComplete();
                Modal.open(
                  <ClassicModal
                    ok={{
                      label: "حسنا",
                      cb: (e) =>
                        router
                          .push(`/user/${authUserId}`)
                          .then(() => Modal.close(e)),
                    }}
                    body={<p>{`تم حذف إعلان رقم (${id}) بنجاح.`}</p>}
                  />,
                )(e);
              })
              .catch((error) => {
                Modal.open(
                  <ClassicModal
                    ok={{
                      label: "حسنا",
                      cb: (e) => Modal.close(e),
                    }}
                    body={
                      <p>
                        {error.message ||
                          "فشل في حذف الإعلان، الرجاء المحاولة لاحقاً."}
                      </p>
                    }
                  />,
                )(e);
              });
          },
        }}
        body={<p>هل أنت متأكد من حذف هذا الإعلان؟</p>}
        title="حذف الإعلان"
      />,
    )(e);
  };

  const openSuccessModal = () => {
    Modal.open(
      <ClassicModal
        newDesign
        close={false}
        cancel={false}
        title="عقار"
        ok={{
          label: "حسنًا",
          cb: (e) => {
            Modal.close(e);
            router.reload();
          },
        }}
        body={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <p style={{ maxWidth: "356px", textAlign: "center" }}>
              تم حفظ التعديلات بنجاح
            </p>
          </div>
        }
      />,
    )();
  };

  const { handlePauseListing } = useListingStatusControl({
    token,
    onSuccess: () => {
      openSuccessModal();
    },
    id: listing.id,
  });

  return (
    <DropDown
      zIndex={100}
      overlay={
        <div className={css.dropdown}>
          <Link
            href={`/edit-listing/v2/${listing.id}?type=media`}
            passHref
            onClick={() => {
              trackStartEditListing({ target: "edit_image" });
            }}
          >
            تعديل الصور
          </Link>
          <Link
            href={`/edit-listing/v2/${listing.id}?type=location`}
            passHref
            onClick={() => {
              trackStartEditListing({ target: "edit_location" });
            }}
          >
            تعديل الموقع
          </Link>
          <Link
            href={`/edit-listing/v2/${listing.id}?type=data&step=general`}
            passHref
            onClick={() => {
              trackStartEditListing({ target: "edit_details" });
            }}
          >
            تعديل التفاصيل
          </Link>
          {!listing?.daily_rentable && (
            <button
              onClick={(e) => {
                trackStartEditListing({ target: "remove_ad" });
                handleCloseListing(e, { id: listing.id });
              }}
              style={{ color: "red" }}
            >
              حذف الإعلان
            </button>
          )}
          {!isPaused && (
            <button
              onClick={(e) => {
                handlePauseListing({ id: listing.id });
              }}
              style={{ color: "red" }}
            >
              إيقاف الإعلان
            </button>
          )}
        </div>
      }
    >
      <button>
        <span>
          <Icon width={15} height={15} name="Edit-listing" />
        </span>
        <span> تعديل </span>
      </button>
    </DropDown>
  );
}
